import ZeroOrGreaterMonetaryAmountInPoundsField from "$routes/price-list/_lib/components/zero-or-greater-monetary-amount-in-pounds-field";
import { gql } from "@apollo/client";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  CenteredInputBox,
  CenteredReadOnlyValue,
  PRICE_LIST_CELL_INPUT_CLASS,
} from "./inline-cell-styles";

gql`
  mutation setPrices($input: SetPricesInput!) {
    priceListV2 {
      setPrices(input: $input) {
        processed
      }
    }
  }
`;

type Props = {
  rowId: string;
  valueInPence: number;
  onChange: (nextInPence: number) => void;
  disabled?: boolean;
};

export const InlinePriceCell: FC<Props> = ({
  rowId,
  valueInPence,
  onChange,
  disabled,
}) => {
  const { formatMessage } = useIntl();

  // Local state shadows the prop so typing into a controlled number input
  // doesn't fight with the parent's batched re-renders. External changes
  // (bulk adjust, refetch) re-sync via the effect below.
  const [local, setLocal] = useState(valueInPence);
  useEffect(() => {
    setLocal(valueInPence);
  }, [valueInPence]);

  if (disabled) {
    return (
      <CenteredReadOnlyValue data-testid={`priceList.row.${rowId}.price`}>
        {(valueInPence / 100).toFixed(2)}
      </CenteredReadOnlyValue>
    );
  }

  return (
    <CenteredInputBox onClick={(e) => e.stopPropagation()}>
      <ZeroOrGreaterMonetaryAmountInPoundsField
        size="small"
        valueInPence={local}
        onChangeInPence={(next) => {
          setLocal(next);
          onChange(next);
        }}
        InputProps={{ classes: { input: PRICE_LIST_CELL_INPUT_CLASS } }}
        inputProps={{
          "aria-label": formatMessage({
            id: "priceList.inlinePrice.input",
            defaultMessage: "Edit price",
          }),
          "data-testid": `priceList.row.${rowId}.price.input`,
        }}
      />
    </CenteredInputBox>
  );
};
